import { ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { groupByLocation, ExcelRow, solutionParticipationProductFilter, SPViewFilterOptions, QueryFilter, PaginationOptions, SolutionParticipationProductInfo, locationViewData,SpProductOrLocationExportPayload } from '../types/solution-participation-types';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltersService } from 'src/app/core/services/filters.service';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { skip, Subscription } from 'rxjs';
import { SolutionParticipationService } from 'src/app/features/solution-participation-details/service/solution-participation.service';
import { CustomPaginator } from '../sku-groupby-view/CustomPaginatorConfigurationLocation';
import { CustomFilterPipe } from '../pipes/custom-filter.pipe';
import { SolutionPartService } from '../service/solution-part.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { SpExcelExportService } from '../service/sp-excelexport.service';
import { CurrencyUomService } from 'src/app/core/services/currency-uom.service';

@Component({
    selector: 'app-sku-groupby-view',
    templateUrl: './sku-groupby-view.component.html',
    styleUrls: ['./sku-groupby-view.component.scss'],
    providers: [
        CustomFilterPipe,
        { provide: MatPaginatorIntl, useValue: CustomPaginator() }
    ],
    standalone: false
})
export class SkuGroupbyViewComponent implements OnInit, OnDestroy {
  // constants
  private static readonly BY_NONUSAGE: string = "by-nonusage";
  private static readonly BY_USAGE: string = "by-usage";
  private currencySubscription: Subscription | undefined;


  groupedData!: locationViewData;
  excelData: ExcelRow[] =[];
  groupedDataPaginated: groupByLocation[] = [];
  exportDataFlag : boolean = false;
  allUsageRowsSelected : boolean = false;
  allNonUsageRowsSelected : boolean = false;
  allRowsSelected: boolean = false;
  rowSelectionByUsage: boolean[] = [];
  rowSelectionByNonUsage: boolean[] = [];
  byDefaultSelectAllUsageRows:boolean=false;
  byDefaultSelectAllNonUsageRows: boolean = true;

  groupBy: string | undefined; //'location' or 'product'
  solutionGroupName: string | undefined; //for page title
  selectedAdvancedFilters: { [id: string]: string[] } = {};
  toggleAdvancedFilterSelection : boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChildren('checkBox') checkBox:QueryList<any> | undefined;

  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;

  isLoading: boolean = false;

  filteredData: groupByLocation[] = [];
  searchTerm: string = '';
  isNonUsage: boolean = false;

  exportAll: boolean = false;
  tabSelected: string = SkuGroupbyViewComponent.BY_USAGE;
  usageLocationsCount: number = 0;
  nonUsageLocationsCount: number = 0;
  isGroupRowChecked:boolean = false;
  locationDataNotFound:boolean = false;

  // Define the sort direction objects to store the direction for each column
  sortDirections: { [key: string]: string } = {
    location: 'asc',
    sales: 'desc',
    cases: 'desc'
  };
  sortBy: string = 'sales';
  sortDirection = 'desc';
  searchFocusStartTime : number | undefined;

  excludeKeys = [];
  displayLoaderForFilterData : boolean = true;
  advancedFilterData: solutionParticipationProductFilter[] = [];
  viewSelectedAdvancedFilters: SPViewFilterOptions = {
    "accountNumber": [],
    "accountName": [],
    "country": [],
    "state": [],
    "city": [],
    "zipCode": [],
    "brand": [],
    "productGroup":[],
    "productName":[],
    "productSku": [],
  };
  filterGroupings: { [id: string]: string[] } = {
    'Account Information Filters': [
      'accountNumber',
      'accountName',
      'country',
      'state',
      'city',
      'zipCode'
    ],
    'Product Level Filters': [
      'brand',
      'productGroup',
      'productName',
      'productSku'
    ]
  };

  viewAdvancedFiltersSubscription: Subscription| undefined;
  currencyCode: string = '';

  paginationOptions: PaginationOptions = {
    limit: 10,
    page: 1,
    sortBy: '',
    sortOrder: '',
    searchTerm: '',
    tabSelected: ''
  };
  totalRecords: number = 0;
  selectedUsageMdmSiteIds: string[] = [];
  selectedNonUsageMdmSiteIds: string[] = [];
  notSelectedUsageMdmSiteIds: string[] = [];
  notSelectedNonUsageMdmSiteIds: string[] = [];
  isDownloadingFile:boolean = false;
  advanceQueryFilters: QueryFilter[] = [];
  spLocationExportFilterPayload!:SpProductOrLocationExportPayload;

  constructor(
    private _filterService: FiltersService,
    private _solutionParticipation: SolutionParticipationService,
    private _route: ActivatedRoute,
    private _router: Router,
    public _solutionParticipationService: SolutionPartService,
    private _mixpanelService: MixpanelService,
    private customFilterPipe: CustomFilterPipe,
    private _spExcelexportService: SpExcelExportService,
    private _currencyUomService: CurrencyUomService,
    private _cdr: ChangeDetectorRef,
  ) { }

  async ngOnInit() {
      this.filtersSubscription = this._filterService.selectedFiltersObservable.subscribe(f => this.filters = f);
      this.viewAdvancedFiltersSubscription = this._solutionParticipation.getLocationDetailsAdvancedFilters().subscribe(advFilter => this.viewSelectedAdvancedFilters = advFilter);

    this.byDefaultSelectAllUsageRows = true;
    if (this.filters != undefined) {
      this._route.queryParams.subscribe(p => {
        this.groupBy = p['groupBy'];
        this.solutionGroupName = p['solutionGroup'];
        this.isNonUsage =  (p['isNonUsage'] == "true");
        this.isGroupRowChecked = p['isProductChecked'];
        this._solutionParticipation.getSummaryAdvancedFilters().subscribe(filters => {
          this.selectedAdvancedFilters = filters;
        });
      });

      if (this.groupBy === undefined || this.solutionGroupName === undefined) {
        this._router.navigate(['/solution-participation-details']);
      }

      this.loadPage();

      this.spLocationExportFilterPayload = this._solutionParticipation.getSpProductorLocationExportPayload();
      this.spLocationExportFilterPayload.exportType = 'Location';
      this.spLocationExportFilterPayload.contractModel = this.filters;

      // Set Advanced Filters
      this.advancedFilterData = this.reorderSolutionFilterData(await this.getAdvancedFilterData());
      if (this.advancedFilterData == undefined)
        this.advancedFilterData = [];
      // Filter the filteroptions as per the default filters
      this.advancedFilterData = this.advancedFilterData.filter(item => {
        const defaultFilters = this._solutionParticipation.defaultFiltersForSummaryDetail;
        const brandFilterEmpty = defaultFilters["brandList"].length === 0 || defaultFilters["brandList"].includes(item.brand);
        const productListEmpty = defaultFilters["productList"].length === 0 || defaultFilters["productList"].includes(item.productSku);
        const productGroupFilterEmpty = defaultFilters["productGroup"] === undefined || defaultFilters["productGroup"].length === 0 || defaultFilters["productGroup"].includes(item.productGroup);
        const productNameFilterEmpty = defaultFilters["productName"] === undefined || defaultFilters["productName"].length === 0 || defaultFilters["productName"].includes(item.productGroup);
        if (brandFilterEmpty && productListEmpty && productGroupFilterEmpty && productNameFilterEmpty) {
          return true;
        } else {
          return false;
        }
      });
      this.getCurrency();
      this.displayLoaderForFilterData = false;
      // Filter the filteroptions as per the default filters

      this.currencySubscription = this._currencyUomService.selectedCurrency$.pipe(skip(1)).subscribe(async () => {
        this.currencyCode = '';
        this._currencyUomService.setCurrencyLoading(true);

        await this.loadPage();

        this._currencyUomService.setCurrencyLoading(false);

        this._cdr.detectChanges();
        this.getCurrency();
      });
    }
    else {
      alert('Please apply filters before navigating to Solution Participation')
      this._router.navigate(['/filter']);
    }
  }

  async loadPage() {
    await this.getData(this.solutionGroupName, this.viewSelectedAdvancedFilters);
  }

  async getData(solution: string | undefined, advProductFilters: SPViewFilterOptions) {
    this.isLoading = true;
    this.groupedData = await this._solutionParticipation.getByLocationData(solution, advProductFilters,this.paginationOptions);
    if (!this.groupedData ||
       (typeof this.groupedData === 'object' && Object.keys(this.groupedData).length === 0)) {
      this.nonUsageLocationsCount = this.usageLocationsCount = this.totalRecords = 0;
      this.isLoading = false;
      return;
    }
    //When user searches for a Product and no data is found
    //dispaly a message 'Location not found'
    if(this?.groupedData?.totalUsageLocationCount === 0 &&
      this?.groupedData?.totalNonUsageLocationCount === 0 &&
      this.searchTerm != ''){
       this.locationDataNotFound = true;
       this.isLoading = false;
      return;
    }
    this.usageLocationsCount = this.groupedData?.totalUsageLocationCount;
    this.nonUsageLocationsCount = this.groupedData?.totalNonUsageLocationCount;

    this.upDateQueryFilter('SOLUTION', this.solutionGroupName ?? '', '=', 'And');

    this.isLoading = false;
    window.scrollTo(0, 0);
    this.groupedDataPaginated = this.groupedData?.locations || [];
    if (!this.isNonUsage) {
      this.tabSelected = SkuGroupbyViewComponent.BY_USAGE;
      this.filterByUsage();
    } else {
      this.tabSelected = SkuGroupbyViewComponent.BY_NONUSAGE;
      this.filterByNonUsage();
    }
  }


  ngOnDestroy(): void {
    if (this.filtersSubscription) {
      this.filtersSubscription.unsubscribe();
    }
    this.selectedNonUsageMdmSiteIds = [];
    this.selectedUsageMdmSiteIds = [];
    if (this.spLocationExportFilterPayload && this.spLocationExportFilterPayload.queryFilters) {
      this.spLocationExportFilterPayload.queryFilters = [];
    }
    this._solutionParticipation.clearLocationViewCache();
    this.currencySubscription?.unsubscribe();
  }


  getAdvancedFilterChips(): string[] {
    const chips: string[] = [];
    Object.keys(this.selectedAdvancedFilters).forEach(key => {
      this.selectedAdvancedFilters[key].forEach(value => {
        chips.push(value);
      });
    });
    return chips;
}

  async onPageChange(event: PageEvent) {
    this.paginationOptions = {
      ...this.paginationOptions,
      page: event.pageIndex + 1,
      limit: event.pageSize
    };
    await this.getData(this.solutionGroupName, this.viewSelectedAdvancedFilters);
  }


  updatePageData(pageIndex: number, pageSize: number) {
    const startIndex = pageIndex * pageSize;
    const endIndex = (pageIndex * pageSize) + pageSize;
    this.groupedDataPaginated = this.filteredData?.slice(startIndex, endIndex);
    if (this.groupedDataPaginated?.length > 0 && this.byDefaultSelectAllUsageRows){
      this.byDefaultSelectAllUsageRows = false;
      this.selectAllRows();
    }

  }

  // Current selected mdmsite id should behave individually for usage and non usage
  getCurrentSelectedArrayByUsageOrNonUsage(): string[] {
    switch (this.tabSelected) {
      case SkuGroupbyViewComponent.BY_NONUSAGE:
        return this.selectedNonUsageMdmSiteIds;
      case SkuGroupbyViewComponent.BY_USAGE:
        return this.selectedUsageMdmSiteIds;
      default:
        return [];
    }
  }

    // Current Not selected mdmsite id should behave individually for usage and non usage
  getCurrentNotSelectedArrayByUsageOrNonUsage(): string[] {
    switch (this.tabSelected) {
      case SkuGroupbyViewComponent.BY_NONUSAGE:
        return this.notSelectedNonUsageMdmSiteIds;
      case SkuGroupbyViewComponent.BY_USAGE:
        return this.notSelectedUsageMdmSiteIds;
      default:
        return [];
    }
  }



  // Selected rows should behave individually for usage and non usage (boolean)
  getCurrentRowSelectionByUsageOrNonUsage(): boolean[] {
    switch (this.tabSelected) {
      case SkuGroupbyViewComponent.BY_NONUSAGE:
        return this.rowSelectionByNonUsage || [];
      case SkuGroupbyViewComponent.BY_USAGE:
        return this.rowSelectionByUsage || [];
      default:
        return [];
    }
  }

  // Export All should behave individually for usage and non usage
   toggleAllRowsSelectedByUsageOrNonUsage(): void {
    const nextSelectionState = !this.allRowsSelected;
    this.allRowsSelected = nextSelectionState;
    this.syncAllRowsSelectionForCurrentTab();
  }

  private syncAllRowsSelectionForCurrentTab(): void {
    if (this.tabSelected === SkuGroupbyViewComponent.BY_NONUSAGE) {
      this.allNonUsageRowsSelected = this.allRowsSelected;
    } else if (this.tabSelected === SkuGroupbyViewComponent.BY_USAGE) {
      this.allUsageRowsSelected = this.allRowsSelected;
    }
  }

  getTotalDistinctProducts(products: SolutionParticipationProductInfo[]): number {
    const distinctProductIDs = new Set(products.map(p => p.productCode));
    return distinctProductIDs.size;
  }

  async onSearchInputChangeEvent() {
    await this.onSearch();

    if (!this.isNonUsage) {
      this.filterByUsage();
    }

    if (this.isNonUsage) {
      this.filterByNonUsage();
    }
  }

  searchLocation() {
    if (this.searchTerm.length < 3) {
      window.alert("Enter at least 3 characters in order to search.")
      return;
    }
  }

 async onSearch() {

    if(this.searchTerm.length < 3){
      if(!this.searchTerm) {
        await this.clear();
      }
      return;
    }
    this.paginationOptions = {
      ...this.paginationOptions,
      searchTerm: this.searchTerm,
    };
    await this.getData(this.solutionGroupName, this.viewSelectedAdvancedFilters);

    this.usageLocationsCount = this.groupedData.totalUsageLocationCount;
    this.nonUsageLocationsCount = this.groupedData.totalNonUsageLocationCount;
  }

  async clear() {
    this.searchTerm = '';
    if (this.filters?.period != undefined) {
    // Reset paginationOptions to initial values
    this.paginationOptions = {
      limit: 10,
      page: 1,
      sortBy: '',
      sortOrder: '',
      searchTerm: '',
      tabSelected: ''
    };

    this.locationDataNotFound = false;
    this.spLocationExportFilterPayload.queryFilters = [];
    await this.getData(this.solutionGroupName, this.viewSelectedAdvancedFilters);
    this.selectedNonUsageMdmSiteIds = [];
    this.selectedUsageMdmSiteIds = [];

   }
  }


  async locUsageChange() {
    if (!this.isNonUsage) {
      await this.onSearch();
      this.filterByUsage();
    }

    if (this.isNonUsage) {
      await this.onSearch();
      this.filterByNonUsage();
    }
  }

  filterByNonUsage() {
    this.locationDataNotFound = (this.nonUsageLocationsCount ?? 0) === 0 && this.searchTerm != '';
    this.filteredData = this.groupedData?.locations?.filter(item => item.isNonUsageLocations === true);
    this.groupedDataPaginated = this.filteredData;
    this.totalRecords = this.nonUsageLocationsCount ?? 0;
    this.updatePageData(0, this.paginator.pageSize);
  }

  filterByUsage() {
    // Filter usage locations
    this.locationDataNotFound = ((this.usageLocationsCount ?? 0)=== 0) && this.searchTerm != '';
    this.filteredData = this.groupedData?.locations?.filter(item => item.isNonUsageLocations != true);
    this.groupedDataPaginated = this.filteredData;
    this.totalRecords = this.usageLocationsCount ?? 0;

    //Paginate data
   this.updatePageData(0, this.paginator.pageSize);
  }


  async changeTab(tab: string) {
    this.tabSelected = tab;
    this.isNonUsage = this.tabSelected === SkuGroupbyViewComponent.BY_NONUSAGE;

    // handle case for export All functionality to behave individually for usage and non usage
    switch (this.tabSelected) {
      case SkuGroupbyViewComponent.BY_NONUSAGE:
        this.allRowsSelected = this.allNonUsageRowsSelected;
        break;

      case SkuGroupbyViewComponent.BY_USAGE:
        this.allRowsSelected = this.allUsageRowsSelected;
        break;
    }

   await this.locUsageChange();

    if(this.tabSelected == SkuGroupbyViewComponent.BY_NONUSAGE && this.byDefaultSelectAllNonUsageRows){
      this.byDefaultSelectAllNonUsageRows = false;
      this.selectAllRows();

    }

  }

  locationDrillClicked(location: groupByLocation, event: Event,i:number) {
    if((location.productCount == 0 && location.accountCount == 0) ||
       (location.productCount == 1 && location.accountCount == 1))
        return;
    if(!(event.target as HTMLElement).closest('.mat-checkbox-inner-container')) {
      let selectedSiteId = location?.mdmSiteId;
      let selectedSiteName = location?.siteName;
      this._router.navigate(['/solution-participation-location-drilldown'], {
        queryParams: {
          solutionGroup: this.solutionGroupName,
          site: selectedSiteId + ' - ' + selectedSiteName.charAt(0).toUpperCase() + selectedSiteName.slice(1),
          isProductChecked: this.getCurrentRowSelectionByUsageOrNonUsage()[i],
          drillBy: location.accountCount > location.productCount ? 'Account' : 'Product',
        }
      });

      this._mixpanelService.track('Location Details Summary Row Clicked', {
          'Location Name': selectedSiteName,
          'Page Name': 'Solution Participation - Location Details'
      });
    }

  }

  async toggleSortDirection(column: string) {
    // Toggle the sort direction for the specified column
    this.sortDirections[column] = this.sortDirections[column] === 'asc' ? 'desc' : 'asc';

    this.sortBy = column;
    this.sortDirection = this.sortDirections[column];

    this.paginationOptions = {
      ...this.paginationOptions,
      sortBy: this._spExcelexportService.getSortedColumnNameForLocation(this.sortBy),
      sortOrder: this.sortDirection,
    };

    await this.getData(this.solutionGroupName, this.viewSelectedAdvancedFilters);

    //MIXPANEL TRACKING
    this._mixpanelService.track('Location Details - Header Sort Icon Clicked', {
      'Column Name': column,
      'Page Name': 'Solution Participation - Location Details',
    });
  }

  onSearchFocus() {
    // Record the start time when the user focuses on the search field
    this.searchFocusStartTime = Date.now();
  }

  onSearchBlur() {
    const blurDurationInMilliseconds = Date.now() - this.searchFocusStartTime!; // Calculate the duration in milliseconds
    const blurDurationInSeconds = (blurDurationInMilliseconds / 1000).toFixed(1) + "sec";
    this._mixpanelService.track('Location Details - Search Box Engagement Duration', {
      'Page Name': 'Solution Participation - Location Details',
      'Duration': blurDurationInSeconds
    });
  }


  async exportAllToExcel() {
    const tabName = this.tabSelected=== SkuGroupbyViewComponent.BY_NONUSAGE ? 'NonUsage' : 'Usage';
    this.spLocationExportFilterPayload.exportType = `Location${tabName}`;
    const currentDate = new Date().toISOString().slice(0, 19).replace(/[-T:/]/g, '');
    const fileName = `EBR__Location_Details_${currentDate}_Solution.xlsx`;
    if(!this.getCurrentRowSelectionByUsageOrNonUsage().includes(true)){
      alert('Please select at least one location to export.');
      return;
    }
    if(this.tabSelected === SkuGroupbyViewComponent.BY_USAGE && this.advanceQueryFilters.length > 0 ) {
      this.spLocationExportFilterPayload.queryFilters?.push(...this.advanceQueryFilters);
    }else{
      if(!this.isAllSelected())
         this.applySiteIdFilter();
    }
     this.isDownloadingFile = true;
     let initializeDownload = true;
     this.spLocationExportFilterPayload.searchTerm = this.searchTerm;
     const fileData = await this._solutionParticipation.DownloadExcel(this.spLocationExportFilterPayload).then(response => {
      if (response) {
         const { data } = response;
         return data;
       }
       initializeDownload = false;
       return null;
     }).catch(error => {
      initializeDownload = false;
      this.isDownloadingFile = false;
       console.log(JSON.stringify(error));
     });
      if (initializeDownload && fileData.size > 0) {
        this._spExcelexportService.executeBrowserDownload(fileData,fileName);

        this._mixpanelService.track('Solution Participation - Location Details - Export Button Clicked', {
          'No Of Records Downloaded and FileName': `${fileData.size} and ${fileName}`,
          'Page Name': 'Solution Participation - Location Details'});
      }else{
        alert('No data found to export.');
      }
      this.isDownloadingFile = false;
      this.spLocationExportFilterPayload.queryFilters = this.spLocationExportFilterPayload.queryFilters?.filter(filter =>
      !filter.columnFilters.hasOwnProperty('SITEID')
    );
    // Clear the Search Term
    this.spLocationExportFilterPayload.searchTerm = '';
  }

  applySiteIdFilter() {
    const isNonUsage = this.tabSelected === SkuGroupbyViewComponent.BY_NONUSAGE;

    const selectedIds = isNonUsage
      ? this.selectedNonUsageMdmSiteIds
      : this.selectedUsageMdmSiteIds;

    const notSelectedIds = isNonUsage
      ? this.notSelectedNonUsageMdmSiteIds
      : this.notSelectedUsageMdmSiteIds;

    if (selectedIds.length > 0) {
      this.upDateQueryFilter('SITEID', selectedIds, 'In', 'And');

    } else if (notSelectedIds.length > 0) {
      this.upDateQueryFilter('SITEID', notSelectedIds, 'Not In', 'And');
    }
  }

  onCheckboxChange(event: MatCheckbox, row: any, i: number): void {
    this.getCurrentRowSelectionByUsageOrNonUsage()[(this.paginator.pageIndex * this.paginator.pageSize) + i] = event.checked;
   const seletedMdmsiteIds = new Set(this.getCurrentSelectedArrayByUsageOrNonUsage());
   const notSeletedMdmsiteIds = new Set(this.getCurrentNotSelectedArrayByUsageOrNonUsage());

    if (event.checked) {
        seletedMdmsiteIds.add(row.mdmSiteId);
        notSeletedMdmsiteIds.delete(row.mdmSiteId);
    } else {
        seletedMdmsiteIds.delete(row.mdmSiteId);
         notSeletedMdmsiteIds.add(row.mdmSiteId);
    }
    // Update the selected and not selected mdm site ids based on the current tab
    if (this.tabSelected === SkuGroupbyViewComponent.BY_NONUSAGE) {
      this.selectedNonUsageMdmSiteIds = Array.from(seletedMdmsiteIds);
      this.notSelectedNonUsageMdmSiteIds = Array.from(notSeletedMdmsiteIds);
    } else {
      this.selectedUsageMdmSiteIds = Array.from(seletedMdmsiteIds);
      this.notSelectedUsageMdmSiteIds = Array.from(notSeletedMdmsiteIds);
    }

    this.allRowsSelected = this.isAllSelected();
    this.syncAllRowsSelectionForCurrentTab();
  }

  selectAllRows() {
    this.toggleAllRowsSelectedByUsageOrNonUsage();
    let count = this.tabSelected === SkuGroupbyViewComponent.BY_NONUSAGE ? this.nonUsageLocationsCount : this.usageLocationsCount;
    for (let i = 0; i < count; i++) {
      this.getCurrentRowSelectionByUsageOrNonUsage()[i] = this.allRowsSelected;
    }
    // Clear the not selected location mdm siteds when all rows are selected.
    if (this.tabSelected === SkuGroupbyViewComponent.BY_NONUSAGE) {
      this.selectedNonUsageMdmSiteIds = [];
      this.notSelectedNonUsageMdmSiteIds = [];
    } else {
      this.selectedUsageMdmSiteIds = [];
      this.notSelectedUsageMdmSiteIds = [];
    }
    this.allRowsSelected = this.isAllSelected();
    this.syncAllRowsSelectionForCurrentTab();
  }

  isAllSelected() {
    return !this.getCurrentRowSelectionByUsageOrNonUsage().some(value => value === false);
  }

  async getAdvancedFilterData() {
    return await this._solutionParticipation.getSummaryDetailsAdvFilters();
  }

  async onSelectedFiltersChange(selectedFilters:{ [id: string]: string[] }) {

    this._solutionParticipation.setLocationDetailsAdvancedFilters(selectedFilters as SPViewFilterOptions);
    this.advanceQueryFilters = this.updatAdvanceFilters(selectedFilters as SPViewFilterOptions);
    if (this.filters?.period != undefined) {
      this.clearExcelOptions();
      await this.getData(this.solutionGroupName, this.viewSelectedAdvancedFilters);
      this.rowSelectionByUsage = [];
      this.rowSelectionByNonUsage = [];
      this.selectAllRows();
      if(this.searchTerm.length >= 3) {
        await this.onSearch();
      }
    }
  }

  clearExcelOptions(){
    this.getCurrentRowSelectionByUsageOrNonUsage().length = 0;
    this.allRowsSelected = false;
    this.byDefaultSelectAllNonUsageRows = true;
    this.byDefaultSelectAllUsageRows = true;
    this.rowSelectionByUsage.length = 0;
    this.rowSelectionByNonUsage.length = 0;
  }

  reorderSolutionFilterData(originalData: any[]): solutionParticipationProductFilter[] {
    return originalData.map((item) => ({
      accountNumber: item.accountNumber,
      accountName: item.accountName,
      country: item.country,
      state: item.state,
      city: item.city,
      zipCode: item.zipCode,
      brand: item.brand,
      productGroup: item.productGroup,
      productName: item.productName,
      productSku: item.productSku
    }));
  }

  getCurrency() {
   this.currencyCode = this._currencyUomService.getCurrencyCode();
  }


   upDateQueryFilter(
    columnName: string,
    filterValue: any,
    filterOperation: "In" | "Not In" | "Equals" | "ILike" | "=" | "!=",
    logicalOperator: "And" | "Or"
  ) {
      this._spExcelexportService.upsertQueryFilter(
        this.spLocationExportFilterPayload,
        columnName,
        filterValue,
        filterOperation,
        logicalOperator);
  }


    /**
     * Updates the advanced filters based on the selected filters.
     * It removes filters that are now empty/cleared and adds new filters for any missing keys.
     * @param selectedFilters The selected filters to update.
     * @returns The updated query filters.
     */
    updatAdvanceFilters(selectedFilters: SPViewFilterOptions): QueryFilter[] {

      return this._spExcelexportService.upsertAdvanceFilters(selectedFilters, this.spLocationExportFilterPayload);
    }
}
